<template>
    <TasksTable
        :tasks="tasks"
        :statuses="statuses"
        :type-with-count="typeWithCount"
        :customer-segments="customerSegments"
        :brands="brands"
        :filter-data="filterData"
        :group-types="groupTypes"
        :marked-as-completed="batchDoneTasks"
        :marked-as-reopened="batchReopenTasks"
        :task-list="taskList"
        route-name="tasks.tasks.index"
        @mark-task-as-completed="markTaskAsCompleted"
        @re-open-task="reOpenTask"
    />
    <BatchMode
        :batch-task-count="batchDoneTasks.length + batchReopenTasks.length"
        @start-batch-mode="startBatchMode"
        @stop-batch-mode="stopBatchMode"
        @save="saveBatchTasks"
        @export="exportToCsv"
    />
</template>

<script>
import BatchMode from '~@/Components/Tasks/BatchMode'
import TasksTable from '~@/Components/Tasks/TasksTable'

export default {
    name: 'TasksIndex',
    components: {
        BatchMode,
        TasksTable
    },
    props: {
        tasks: {
            type: Object,
            default: () => { return {} }
        },
        typeWithCount: {
            type: Array,
            default: () => { return [] }
        },
        statuses: {
            type: Array,
            default: () => { return [] }
        },
        brands: {
            type: Array,
            default: () => { return [] }
        },
        customerSegments: {
            type: Array,
            default: () => { return [] }
        },
        filterData: {
            type: Object,
            default: () => { return {} }
        },
        groupTypes: {
            type: Array,
            default: () => { return [] }
        },
        taskList: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            batchMode: false,
            batchDoneTasks: [],
            batchReopenTasks: []
        }
    },
    methods: {
        markTaskAsCompleted (taskId) {
            if (this.batchMode) {
                if (this.batchReopenTasks.includes(taskId)) {
                    this.batchReopenTasks = this.batchReopenTasks.filter(id => id !== taskId)
                } else if (this.batchDoneTasks.includes(taskId) === false) {
                    this.batchDoneTasks.push(taskId)
                }
            } else {
                this.$inertia.get(this.$route('tasks.tasks.mark-as-completed', {
                    task: taskId
                }))
            }
        },
        reOpenTask (taskId) {
            if (this.batchMode) {
                if (this.batchDoneTasks.includes(taskId)) {
                    this.batchDoneTasks = this.batchDoneTasks.filter(id => id !== taskId)
                } else if (this.batchReopenTasks.includes(taskId) === false) {
                    this.batchReopenTasks.push(taskId)
                }
            } else {
                this.$inertia.get(this.$route('tasks.tasks.re-open-task', {
                    task: taskId
                }))
            }
        },
        saveBatchTasks () {
            this.$inertia.post(this.$route('tasks.tasks.batch-save'), {
                done: this.batchDoneTasks,
                reopen: this.batchReopenTasks
            }, {
                onSuccess: () => {
                    this.stopBatchMode()
                }
            })
        },
        exportToCsv () {
            window.location.href = this.$route('tasks.tasks.export', this.filterData)
        },
        startBatchMode () {
            this.batchMode = true
        },
        stopBatchMode () {
            this.batchMode = false
            this.batchDoneTasks = []
            this.batchReopenTasks = []
        }
    }
}
</script>
